import { heroEquipment } from "../HeroEquipment";

export const pogromcy = {
  heroes: {
    "Tan pogromców": {
      id: 0,
      startingEquipment: ["Sztylet", "Topór krasnoludów"],
      cost: 85,
      number: 1,
      equipmentList: heroEquipment["Kult Pogromców z Karak Kadrin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 5, 4, 4, 4, 2, 3, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Dowódca",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Rewelator",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 5],
    },
    "Kowal run": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Kult Pogromców z Karak Kadrin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: ["Błogosławieństwo Valayi","Kowal Run","Krzepki","Nieustępliwy","Ochronne tatuaże","Odporność na magię (2)","Pogromca","Rankor","Rozproszenie magii (1)","Trudny do zabicia","Uporczywość","Wspinaczka","Zabobonny lęk"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Mistrz inżynier": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Kult Pogromców z Karak Kadrin"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Mistrz inżynier",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 1, 2, 3, 5],
    },
    "Pogromca smoków": {
      id: 3,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 55,
      number: 1,
      equipmentList: {
        "Broń wielka": [10,0],
        "Buława/Maczuga/Młot bojowy": [5,0],
        "Cep bojowy": [10,0],
        "Sztylet": [2,0],
        "Topór bojowy/Nadziak": [5,0],
        "Topór krasnoludów": [10,0],
        "Broń miotana (ładunki wybuchowe)": [15,1],
        "Kusza": [25,1],
        "Muszkiet krasnoludzki": [25,1],
        "Pistolet dubeltowy": [15,1],
        "Pistolet pojedynkowy": [20,1]
      },
      type: "Bohater",
      stats: {
        Początkowa: [3, 6, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 10,
      skills: [0, 3, 4, 5],
    },
    "Pogromca gigantów": {
      id: 4,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 1,
      equipmentList: {
        "Broń wielka": [10,0],
        "Buława/Maczuga/Młot bojowy": [5,0],
        "Cep bojowy": [10,0],
        "Sztylet": [2,0],
        "Topór bojowy/Nadziak": [5,0],
        "Topór krasnoludów": [10,0],
        "Broń miotana (ładunki wybuchowe)": [15,1],
        "Kusza": [25,1],
        "Muszkiet krasnoludzki": [25,1],
        "Pistolet dubeltowy": [15,1],
        "Pistolet pojedynkowy": [20,1]
      },
      type: "Bohater",
      stats: {
        Początkowa: [3, 5, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    "Pogromca trolli": {
      id: 5,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 12,
      equipmentList: {
        "Broń wielka": [10,0],
        "Buława/Maczuga/Młot bojowy": [5,0],
        "Cep bojowy": [10,0],
        "Sztylet": [2,0],
        "Topór bojowy/Nadziak": [5,0],
        "Topór krasnoludów": [10,0],
        "Broń miotana (ładunki wybuchowe)": [15,1],
        "Kusza": [25,1],
        "Muszkiet krasnoludzki": [25,1],
        "Pistolet dubeltowy": [15,1],
        "Pistolet pojedynkowy": [20,1]
      },
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Bukanier: {
      id: 6,
      startingEquipment: ["Pistolet"],
      cost: 55,
      number: 5,
      equipmentList: heroEquipment["Kult Pogromców z Karak Kadrin"].Bukanier,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rajtar",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wodny",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Wyklęty: {
      id: 7,
      startingEquipment: ["Topór krasnoludów", "Topór krasnoludów"],
      cost: 55,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["K6", 5, 3, 4, 4, 1, 2, 1, 10],
        Maksymalna: ["K6", 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Berserk",
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Stan niższy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wir śmierci",
        "Wspinaczka",
        "Wyklęty",
        "Zabobonny lęk",
      ],
    },
    Żyrokopter: {
      id: 8,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Początkowa: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
        Maksymalna: [2, "-", "-", 4, 5, 5, "-", "-", "-"],
      },
      rules: [
        "Bombardowanie (płonący atak)",
        "Duży cel",
        "Kusza parowa",
        "Lot",
        "Machina wojenna",
        "Trafienie z uderzenia",
        "Uporczywość",
        "Zawis",
        "Zwiadowca",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Kult Pogromców z Karak Kadrin",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (1)", "Reduta", "Rozrzutność"],
  mercenaries: [],
};
